/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

// @material-ui/core components
import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  FormGroup,
  FormLabel,
  Grid,
  OutlinedInput,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import NumericFormat from "react-number-format";

// Karsten
import HeaderClientes from "components/_refactor/headers/clients";

import componentStyles from "assets/theme/views/admin/react-bs-table";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useCustomStyles = makeStyles({
  fields: {
    display: "flex",
    flexDirection: "column",
    width: 300,
    marginTop: "1rem",
  },
  option: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    wordBreak: "keep-all",
  },
  paper: {
    width: "max-content !important",
    minWidth: "100%",
  },
  popper: {
    maxWidth: "calc(100% - 60px - 1.5rem)",
    width: "max-content",
  },
});

function GerenciamentoRegrasComissao() {
  const classes = { ...useStyles(), ...useCustomStyles() };

  const isMobile = IsMobile();

  const snackbar = useSnackbar();

  const itemXS = isMobile ? 12 : 6;

  const [commissionPercentage, setCommissionPercentage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchingPercentage, setIsSearchingPercentage] = useState(true);

  const onSubmit = async () => {
    if (isLoading) return;
    try {
      setIsLoading(true);

      console.log(commissionPercentage);

      await Api.put("edit-parameter", "configuracoesOmni", {
        percentualComissaoVendedorPi: String(commissionPercentage),
        idMarca: "0",
        idCanal: "0",
        idPessoaRepresentante: "0",
        idGrupoEconomico: "0",
        idPessoaLoja: "0",
      });

      snackbar.showMessage("Regra de comissão atualizada com sucesso", {
        severity: "success",
      });
    } catch (error) {
      console.log(error);
      snackbar.showMessage("Erro ao atualizar regra de comissão", {
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleGetStoreParameters = async () => {
      try {
        setIsSearchingPercentage(true);
        const response = await Api.get(
          "parameter-list",
          "configuracoesOmni",
          "",
          true
        );

        const commissionPercentage = response?.Result?.find(
          (item) => item.Modalidade === "PI"
        )?.PercentualComissaoVendedorPi;

        if (commissionPercentage >= 0) {
          setCommissionPercentage(commissionPercentage);
        }
      } catch (error) {
        snackbar.showMessage(error, {
          severity: "error",
        });
      } finally {
        setIsSearchingPercentage(false);
      }
    };

    handleGetStoreParameters();
  }, []);

  console.log(commissionPercentage);

  return (
    <>
      <HeaderClientes section="Regras de Comissão" subsection="Gerenciamento" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Regras"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>

              <Grid
                item
                xs={itemXS}
                style={{ marginLeft: "0.5rem", marginTop: "2rem" }}
              >
                <FormGroup style={{ width: "100%" }}>
                  <FormLabel>Percentual de Comissão</FormLabel>
                  <NumericFormat
                    fullWidth
                    disabled={isSearchingPercentage}
                    className={classes.input}
                    value={commissionPercentage}
                    onValueChange={({ value }) => {
                      setCommissionPercentage(value);
                    }}
                    decimalSeparator=","
                    isNumericString
                    customInput={OutlinedInput}
                  />
                </FormGroup>
              </Grid>
              <Grid>
                <Button
                  style={{
                    margin: "1.5rem",
                  }}
                  variant="contained"
                  disabled={
                    (!commissionPercentage &&
                      commissionPercentage === 0 &&
                      (commissionPercentage < 0 ||
                        commissionPercentage > 100)) ||
                    isLoading
                  }
                  onClick={onSubmit}
                >
                  {isLoading ? "Atualizando..." : "Atualizar"}
                </Button>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export { GerenciamentoRegrasComissao };
